// @flow

import React from "react";

import * as Sentry from "@sentry/browser";

import createHistory from "history/createBrowserHistory";

import config from "../configs/envConfig";
// const getUrlParams = (paramString, key) => {
// // generalise this fn to accept an array of keys and return an object having val corresponding to each key
//   const urlParams = new URLSearchParams(paramString);
//   return urlParams.get(key);

// };

export function enableSentry() {
  if (process.env.NODE_ENV === "prod") {
    Sentry.init({
      dsn: "https://55f64f6e309742c095adfec1f2d96c5a@sentry.io/1488019"
    });
  }
}

export const attachmentFileSizeInMB = 15;

export const history = createHistory({ basename: `${config.baseName}/#` });

export const windowOpen = (url: string, target: string) => {
  // basename is used in vishwakarma -> zoom-vk.stg.rivigo.com/qa/ticketing-ui/#/createticket
  if (url) {
    return window.open(config.baseName + url, target);
  }
  return window.open(url, target);
};

export const isArrayNonEmpty = (testArray: Array<any>) =>
  testArray && testArray.length > 0;

export const isStringNonEmpty = (testString: string) =>
  testString && testString.length > 0;

export const isEwayBillPaternValid = (testEwayBill: string) =>
  Number(testEwayBill) === 0 ||
  (Number(testEwayBill) > 0 &&
    Number(testEwayBill) % 1 === 0 &&
    testEwayBill.length === 12);

export const getSelectOptionList = (tableData?: Object, columnKey: string) => {
  const selectOptionListMap = {};
  const selectOptionList = [];

  tableData.forEach(row => {
    const columnVal = row[columnKey];
    if (!Object.prototype.hasOwnProperty.call(selectOptionListMap, columnVal)) {
      selectOptionListMap[columnVal] = columnVal;
      selectOptionList.push({ key: columnVal, val: columnVal });
    }
  });

  return selectOptionList;
};

export const filterForColumnSum = (row: Object, filterObject: Object) => {
  const filterArrayLength = filterObject.filterColummnKeys.length;

  for (let i = 0; i < filterArrayLength; i += 1) {
    if (
      row[filterObject.filterColummnKeys[i]].toLowerCase() !==
      filterObject.filterValues[i].toLowerCase()
    ) {
      return false;
    }
  }

  return true;
};

export const getColumnSum = (
  tableData: Object,
  columnKey: string,
  filterObject?: Object,
  filterFunction?: Function
) => {
  let columnSum = 0;

  if (tableData) {
    tableData.forEach(row => {
      if (
        filterObject === null ||
        (filterObject !== null && filterFunction
          ? filterFunction(row, filterObject)
          : filterForColumnSum(row, filterObject))
      ) {
        columnSum += row[columnKey];
      }
    });
  }

  return columnSum;
};

export const appUpdateWarnings = {
  message: "App version is outdated. Please refresh to continue.",
  refreshRequiredConfirm: "Refresh required: Confirmed",
  refreshRequiredCancel: "Refresh required: Cancelled"
};

export const strUsables: Object = {
  emptySpace: " ",
  eqString: "=",
  accessToken: "access_token",
  bearerString: "Bearer",
  commaString: ",",
  openBracket: "(",
  closeBracket: ")",
  indianCurrencySymol: "₹"
};

export const roundOff = (num, point) =>
  Number(typeof point === "number" ? num.toFixed(point) : num.toFixed(2));

export const getFormattedDate = (epochTime: numeric) =>
  new Date(epochTime).toLocaleDateString("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric"
  });

export const getFormattedTime = (epochTime: numeric) =>
  new Date(epochTime).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true
  });

export const getFormattedDateAndTime = (epochTime: numeric) =>
  `${getFormattedDate(epochTime)}, ${getFormattedTime(epochTime)}`;

export const getRetailTableCellObject = (
  dataUp: string,
  dataDown: string,
  rowData: Object,
  clickHandler1: Function,
  customClass1
) => (
  <div className="flex-100">
    <div
      className={`${
        // eslint-disable-next-line
        customClass1 ? customClass1 : ""
      } text-wrap-ellipsis`}
      title={dataUp}
      onClick={() =>
        clickHandler1 &&
        typeof clickHandler1 === "function" &&
        clickHandler1(rowData)
      }
    >
      {dataUp}
    </div>
    <div className="text-wrap-ellipsis" title={dataDown}>
      {dataDown}
    </div>
  </div>
);

export const indianCurrency = (amount: String) => <div>&#8377;{amount}</div>;

export const getCollectionsHandoverTableCellObject = (
  cashAmount,
  chequeAmount
) => (
  <div>
    <div className="flex-20">&#8377;{roundOff(cashAmount + chequeAmount)}</div>
    <div className="flex-20">Cash(&#8377;{cashAmount})</div>
    <div className="flex-20">Cheque(&#8377;{chequeAmount})</div>
  </div>
);

export const getNameNumberObject = (obj, nameAccessor, numberAccessor) =>
  obj[nameAccessor] +
  strUsables.emptySpace +
  strUsables.openBracket +
  obj[numberAccessor] +
  strUsables.closeBracket;

export const getNameNumberList = (list, nameAccessor, numberAccessor) => {
  const toReturn = [];
  if (!list) {
    return toReturn;
  } else if (!list.length) {
    return toReturn;
  }
  list.map(obj => {
    toReturn.push(getNameNumberObject(obj, nameAccessor, numberAccessor));
    return obj; // Returning only for es-lint
  });
  return toReturn;
};

export const getPaymentTypeCell = (type, bank, cheque) => {
  let toReturn = type;
  const typeLowerCase = type && type.toLowerCase();
  if (typeLowerCase === "cash") {
    return toReturn;
  } else if (typeLowerCase === "cheque") {
    toReturn = `Cheque | ${bank}`;
    return getRetailTableCellObject(toReturn, cheque);
  }
  return type;
};

export const formattedList = (list, separatorStr) => {
  let separator = ", ";
  if (separatorStr) {
    separator = separatorStr;
  }
  return list.join(separator);
};

export const isAuthorized = (userProfile: Object, route: Object) => {
  const { roles } = route;
  let isAuthorizedVar = false;
  if (roles && roles.length) {
    roles.forEach(role => {
      if (userProfile && userProfile.authorities.indexOf(role) !== -1) {
        isAuthorizedVar = true;
      }
    });
    if (userProfile && route.locationAllowed) {
      isAuthorizedVar =
        route.locationAllowed.indexOf(userProfile.location_id) !== -1;
    }
  } else {
    // No role authentication present
    isAuthorizedVar = true;
  }
  return isAuthorizedVar;
};

export const checkAuthentication = (routeObj: Object, userProfile: Object) => {
  let isAuthorizedVar = false;
  if (typeof routeObj.isAuthorized === "function") {
    isAuthorizedVar = routeObj.isAuthorized(userProfile, routeObj);
  } else {
    isAuthorizedVar = isAuthorized(userProfile, routeObj);
  }
  if (isAuthorizedVar && routeObj && routeObj.route === "cashbook") {
    if (routeObj.cashbookV1) {
      isAuthorizedVar = !userProfile.cashBookV2Allowed;
    } else {
      isAuthorizedVar = userProfile.cashBookV2Allowed;
    }
  }
  if (
    isAuthorizedVar &&
    routeObj &&
    (routeObj.route === "/collections-handover" ||
      routeObj.route === "/retail-collections" ||
      routeObj.route === "/retail-cashbook")
  ) {
    isAuthorizedVar = userProfile.cashBookV2Allowed;
  }
  return isAuthorizedVar ? routeObj : null;
};

export const getRouteObjFromPath = (
  pathStr: string,
  routesConfig: Array<any>
) => {
  let matchedRouteObj = {};
  routesConfig.filter(routeObj => {
    if (routeObj.subRoutes) {
      const subRouteEntered = routeObj.subRoutes.filter(
        subRouteObj => subRouteObj.route.indexOf(pathStr) >= 0
      );
      if (subRouteEntered.length) {
        [matchedRouteObj] = subRouteEntered;
        return true;
      }
      return false;
    }

    if (routeObj.route.indexOf(pathStr) >= 0) {
      matchedRouteObj = routeObj;
      return true;
    }
    return false;
  });
  return matchedRouteObj;
};

export const getRedirectPath = (pathStr: string, routesConfig: Array<any>) => {
  const matchedRouteObj = getRouteObjFromPath(pathStr, routesConfig);
  // eslint-disable-next-line
  console.log(" inside getRedirectPath, matchedRouteObj: = ", matchedRouteObj);
  return "/"; // update it to redirect to matchedRouteObj.defaultPath or pagenotfound
};

export const checkUserAccessOnRoute = (
  pathStr: string,
  userProfile: Object,
  routesConfig: Array<any>
) => {
  const matchedRouteObj = getRouteObjFromPath(pathStr, routesConfig);
  const isAuthorizedVar = checkAuthentication(matchedRouteObj, userProfile);
  if (isAuthorizedVar) {
    return true;
  }
  return false;
};

export const getCookie = (cname: string) => {
  const name = cname + strUsables.eqString;
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const setAuthHeader = () => {
  const bearerToken = getCookie(strUsables.accessToken);
  const authHeaderString =
    strUsables.bearerString + strUsables.emptySpace + bearerToken;
  return authHeaderString;
};

export const getUniqueId = (length: number) => {
  const randomNo = Math.random();
  const digits = 10 ** length;
  return parseInt(randomNo * digits, 10);
};

export const shouldTableDataBeFetchedForNewDateRange = (
  nextDateFilterValues,
  presentDateFilterValues
) =>
  nextDateFilterValues &&
  presentDateFilterValues &&
  nextDateFilterValues.startDate &&
  nextDateFilterValues.endDate &&
  (nextDateFilterValues.startDate !== presentDateFilterValues.startDate ||
    nextDateFilterValues.endDate !== presentDateFilterValues.endDate);

export const downloadArrayBufferAsXLS = (data, fileName) => {
  const blob = new Blob([data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};

export const getPaymentTypeString = (mode: string) => {
  let paymentType = "";

  if (mode === "COD") {
    paymentType = "TO PAY";
  } else if (mode === "PREPAID") {
    paymentType = "PAID";
  }
  return paymentType;
};

export const sendGaEvent = (
  eventObj: Object,
  action: string,
  userProfile: Object
) => {
  // eslint-disable-next-line no-console
  console.log("GA event object {} ", eventObj);
  if (window.gtag) {
    window.gtag(
      "event",
      action,
      Object.assign(eventObj, {
        userId: userProfile && userProfile.email,
        userLocation: userProfile && userProfile.location_code,
        userOrg: userProfile && userProfile.organizationId
      })
    );
  }
};

export const navigateToRouteHelper = (routeObj: Object, newWindow: Boolean) => {
  if (routeObj.route) {
    if (routeObj.previousRoute) {
      if (newWindow) {
        window.open(`${config.oldDomainUrl}${routeObj.route}`, "_blank");
      } else {
        window.location = config.oldDomainUrl + routeObj.route;
      }
      // eslint-disable-next-line no-console
      console.log(" navigate to old route: '/#/'", routeObj.route);
    } else {
      if (newWindow) {
        const currentUrl = window.location.origin;
        window.open(
          `${currentUrl}${config.baseName}/#${routeObj.route}`,
          "_blank"
        );
      } else {
        history.push(`${routeObj.route}`);
      }
      // eslint-disable-next-line no-console
      console.log(" navigate to route: '/'", routeObj.route);
    }
  }
};

export const validateMobileNumber = mobilenumber => {
  const validregex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return mobilenumber && mobilenumber.match(validregex);
};

export const enableOnlyNumberInput = (event, input: String, maxInputLength) => {
  if (
    event.which < 48 ||
    event.which > 57 ||
    (maxInputLength && input && input.length === maxInputLength)
  ) {
    event.preventDefault();
  }
};

export const getFormattedSLAFromMillis = timeDiff => {
  timeDiff /= 1000;
  const days = Math.floor(timeDiff / 86400);
  timeDiff -= days * 86400;

  let displayDays;
  if (days && days === 1) {
    displayDays = "1 day";
  } else if (days && days > 1) {
    displayDays = `${days} days`;
  } else {
    displayDays = "";
  }

  // calculate (and subtract) whole hours
  const hours = Math.floor(timeDiff / 3600) % 24;
  timeDiff -= hours * 3600;

  let displayHrs;
  if (hours && hours === 1) {
    displayHrs = "1 hr";
  } else if (hours && hours > 1) {
    displayHrs = `${hours} hrs`;
  } else {
    displayHrs = "";
  }

  // calculate (and subtract) whole minutes
  const minutes = Math.floor(timeDiff / 60) % 60;
  timeDiff -= minutes * 60;

  let displayMins;
  if (minutes && minutes === 1) {
    displayMins = "1 min";
  } else if (minutes && minutes > 1) {
    displayMins = `${minutes} mins`;
  } else {
    displayMins = "";
  }
  if (displayDays === "" && displayHrs === "" && displayMins === "") {
    return "--";
  }
  return `${displayDays} ${displayHrs} ${displayMins}`;
};

export const isValidEmail = email => {
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const isNullOrEmptyString = inputString =>
  inputString === null || inputString === "";

export const getNestedValue = (nestedObjects, row) => {
  let val;
  for (let i = 0; i < nestedObjects.length; i += 1) {
    const key = nestedObjects[i];
    if (i === 0 && row[key]) {
      val = row[key];
    } else if (val && val[key]) {
      val = val[key];
    } else {
      val = null;
      break;
    }
  }
  return val;
};

const columnAccessorNested = (column, data) => {
  const nestedAccessor = column.accessor ? column.accessor.split(".") : null;
  return nestedAccessor ? getNestedValue(nestedAccessor, data) : null;
};

export const downloadCSV = (csvData, fileName) => {
  const csvBlob = new Blob([csvData], { type: "text/csv" });
  const uri = URL.createObjectURL(csvBlob);
  const link = document.createElement("a");
  link.href = uri;
  link.style.visibility = "hidden";
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const createCSV = (JSONData, fileName, columns) => {
  const tableData =
    typeof JSONData !== "object" ? JSON.parse(JSONData) : JSONData;
  let CSV = "";
  let row = "";
  const headers = [];

  if (columns) {
    columns.forEach(column => {
      if (column.accessor) {
        const headerValue = column.Header;
        row += `${headerValue},`;
        headers.push(column);
      }
    });
  }
  CSV += `${row}\r\n`;

  tableData.forEach(data => {
    row = "";
    headers.forEach(header => {
      if (typeof header.formatter === "function") {
        const value = header.formatter(data);
        row += `"${value}",`;
      } else {
        const value = columnAccessorNested(header, data);
        row += `"${value}",`;
      }
    });
    CSV += `${row}\r\n`;
  });

  if (!CSV) {
    return "";
  }
  return CSV;
};

export const jsonToCSVConvertor = (JSONData, fileName, columns) => {
  const CSV = createCSV(JSONData, fileName, columns);
  downloadCSV(CSV, fileName);
};



// WEBPACK FOOTER //
// ./app/services/helpers.js